import { useStore } from "@/shared/store/useStore.js";
import specialityStore from "@/modules/Quote/store/specialityStore.js";

/**
 * Subscribe to the currently-loaded speciality master.
 * @returns {import("@/shared/dtos").SpecialityMasterResponse | null}
 */
export function useSpeciality() {
  return useStore(specialityStore, (s) => s.currentSpeciality);
}

/** Convenience shorthand for the speciality id (number) or undefined. */
export function useSpecialityId() {
  const sp = useSpeciality();
  return sp?.id;
}
